export type Timestamp = string | Date;

export interface ResponseModel<T> extends Object {
  data: T;
}
